import Vue from 'vue';
import App from './App.vue';
import './assets/styles/styles.scss';

import UIkit from './js/uikit-core';
window.UIkit = UIkit;

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount('#app');
